import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { status } from '../../constants'
import { FONTS } from '../../../../constants'
import { getExcludeVat } from '../../../../function/billing'

export const ARItem = React.memo(({
  item,
  index,
  billing,
  handleClickEdit,
  goToProjectInfo,
}) => {
  const _status = status.find(s => s.value === item.status)
  const excludeVat = getExcludeVat(item)
  const { accountant_billings = [] } = billing
  const { billing_id } = item

  const accountantBilling = accountant_billings.find(ab => ab.billing_id === billing_id) || null
  const updateBy = accountantBilling ? accountantBilling.update_by : ''
  const updated = accountantBilling ? moment(accountantBilling.updated).format('DD/MM/YYYY HH:mm') : '-'
  const isBefore = item.invoice_date && moment(item.invoice_date).isBefore(moment())

  const handleClickRow = () => {
    if (item.status === 'PLANNING') {
      goToProjectInfo(item.project_id)
    } else {
      handleClickButton()
    }
  }

  const handleClickButton = () => {
    handleClickEdit(index, item.billing_id)
  }

  return (
    <Root onClick={ handleClickRow }>
      <ProjCol>
        <BoldText>
          { billing.project_code } { billing.project_name }
          <div id='tooltip-proj'>{ billing.project_code } { billing.project_name }</div>
        </BoldText>
        <SubText>{ item.name }</SubText>
      </ProjCol>
      <LOBCol>
        <BoldText>{ billing.lob_name }</BoldText>
        <SubText>{ billing.client_name }</SubText>
      </LOBCol>
      <PMCol>
        <NameText>
          { billing.key_pm_name }
          <div id='tooltip-pm'>{ billing.key_pm_name }</div>
        </NameText>
      </PMCol>
      <MilestoneCol>
        <Number>{ `${billing.billing_no}/${billing.billings.length}` }</Number>
      </MilestoneCol>
      <AmountCol>
        <Number>{`฿ ${excludeVat}`}</Number>
      </AmountCol>
      <DateCol>
        <Number is_before={ isBefore }>
          { item.invoice_date ? moment(item.invoice_date).format('DD/MM/YYYY') : '-' }
        </Number>
      </DateCol>
      <DateCol>
        <Number>
          { accountantBilling && accountantBilling.cash_receive_date ? moment(accountantBilling.cash_receive_date).format('DD/MM/YYYY') : '-' }
        </Number>
      </DateCol>
      <StatusCol>
        <StatusWrapper status={ _status }>
          <Dot status={ _status } />
          { _status ? _status.label : '-' }
        </StatusWrapper>
        <div id='tooltip-status'>{ _status ? _status.description : '-' }</div>
      </StatusCol>
      <TextWrapper>
        <Number>{ updated }</Number>
        <SubtitleText>{ updateBy }</SubtitleText>
      </TextWrapper>
      {/* <ButtonWrapper>
        <Button
          width='70px'
          height='26px'
          theme='#28a745'
          onClick={ handleClickButton }
          icon={ <FaRegEdit style={ { fontSize: 16, pointerEvents: 'none' } } /> }
        >
          Edit
        </Button>
      </ButtonWrapper> */}
    </Root>
  )
})

const Root = styled.div`
  min-height: 50px;
  display: grid;
  grid-template-columns: minmax(auto, 250px) minmax(auto, 150px) minmax(auto, 150px) 100px 1fr 100px 100px 100px 120px;
  grid-gap: 24px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  background: #FFFFFF;
  padding: 0 24px;
  border-top: 1px solid #F1F1F1;
  cursor: pointer;

  :nth-child(1) {
    border: none;
  }

  #arrow {
    transform: ${p => (p.active ? 'rotate(90deg)' : 'rotate(0deg)')};
    transition: all 0.3s;
  }

  @media (max-width: 1440px) {
    width: fit-content;
    grid-template-columns: 150px 100px 100px 100px 150px 100px 100px 100px 120px;
  }

  @media (max-width: 1024px) {
    width: fit-content;
    grid-template-columns: 150px 100px 100px 100px 150px 100px 100px 100px 120px;
  }
`

const ProjCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;

  #tooltip-proj {
    position: fixed;
    max-width: 300px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
    white-space: normal;
    z-index: 1;
  }

  #tooltip-proj::after {
    position: absolute;
    bottom: 100%;
    left: 50%;
  }

  :hover {
    #tooltip-proj {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const LOBCol = styled(ProjCol)``

const PMCol = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;

  #tooltip-pm {
    position: fixed;
    max-width: 300px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
    white-space: normal;
    z-index: 1;
  }

  #tooltip-pm::after {
    position: absolute;
    bottom: 100%;
    left: 50%;
  }

  :hover {
    #tooltip-pm {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const MilestoneCol = styled(ProjCol)`
`

const AmountCol = styled(ProjCol)`
  align-items: flex-end;
`

const DateCol = styled(ProjCol)`
`

const StatusCol = styled.div`
  display: block;
  margin: auto 0;
  cursor: pointer;

  #tooltip-status {
    position: fixed;
    max-width: 300px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
    white-space: normal;
    z-index: 1;
  }

  #tooltip-status::after {
    position: absolute;
    bottom: 100%;
    left: 50%;
  }

  :hover {
    #tooltip-status {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`

const SubtitleText = styled(Text)`
  width: 95%;
  color: #808080;
`

const NameText = styled(Text)`
  position: relative;
  display: block;
`

const BoldText = styled(Text)`
  font-family: ${FONTS.GOTHAM_BOLD};
  position: relative;
  display: block;
`

const SubText = styled(Text)`
  color: #808080;
`

const Number = styled.span`
  font-family: ${FONTS.NOTOSANS};
  font-size: ${FONTS.SMALL_SIZE};
  color: ${p => (p.is_before ? '#D44B49' : '#1A1A17')};
`

const StatusWrapper = styled.div`
  min-width: 110px;
  width: fit-content;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.status ? p.status.bg : '')};
  color: ${p => (p.status ? p.status.color : '')};
  border-radius: 4px;
  padding: 0 10px;
`

const Dot = styled.div`
  width: 6px;
  height: 6px;
  background: ${p => (p.status ? p.status.color : '')};
  border-radius: 50%;
  margin-right: 6px;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ar-billing/ar-item.js